module.exports = __webpack_public_path__ + "static/media/logo-npr-text.57995f11.svg";